import { render, staticRenderFns } from "./UnqualifiedPlaceholder.vue?vue&type=template&id=77596a5b&scoped=true&"
import script from "./UnqualifiedPlaceholder.vue?vue&type=script&lang=js&"
export * from "./UnqualifiedPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77596a5b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
